class OaklenPageToolbar extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;

    this.initialized = true;
    this.sortSelect = this.querySelector('[data-oaklen-toolbar-sort]');
    this.countElement = this.querySelector('[data-oaklen-toolbar-count]');
    this.countLabel = this.getCountLabel();
    this.targetSelector = this.normalizeTarget(this.dataset.target || '#grid');
    this.handleResultsChange = this.handleResultsChange.bind(this);

    this.sortSelect?.addEventListener('change', () => {
      this.dispatchEvent(
        new CustomEvent('oaklen:sort-change', {
          bubbles: true,
          detail: {
            target: this.targetSelector,
            value: this.sortSelect.value,
          },
        })
      );
    });

    document.addEventListener('oaklen:results-change', this.handleResultsChange);
  }

  disconnectedCallback() {
    document.removeEventListener('oaklen:results-change', this.handleResultsChange);
  }

  handleResultsChange(event) {
    if (!this.matchesTarget(event.detail?.target)) return;

    if (this.countElement) {
      this.countElement.textContent = `${event.detail?.count || 0} ${this.countLabel}`;
    }
  }

  matchesTarget(target) {
    return !target || this.normalizeTarget(target) === this.targetSelector;
  }

  getCountLabel() {
    const text = this.countElement?.textContent.trim() || 'series';
    return text.replace(/^\d+\s*/, '') || 'series';
  }

  normalizeTarget(target) {
    if (!target) return '#grid';

    const trimmed = String(target).trim();
    return trimmed.startsWith('#') ? trimmed : `#${trimmed}`;
  }
}

if (!customElements.get('oaklen-page-toolbar')) {
  customElements.define('oaklen-page-toolbar', OaklenPageToolbar);
}
